import React from 'react';

function DarkFaqClassGroups(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      width={52}
      height={52}
      viewBox='0 0 52 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect width={52} height={52} rx={4} fill='#5B316D' />
      <mask
        id='mask0_10148_43202'
        style={{
          maskType: 'alpha'
        }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={10}
        width={32}
        height={32}
      >
        <rect x={10} y={10} width={32} height={32} fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_10148_43202)'>
        <path
          d='M11.9319 27.7372C12.2048 25.5164 14.0865 23.6141 16.299 23.3453H20.5627C20.5172 24.59 21.2946 25.7811 22.0514 26.6785C19.2393 27.4642 17.4486 30.1482 17.8208 33.5269C15.8027 33.4814 13.7928 32.9768 11.9277 32.3896V27.7372H11.9319Z'
          fill='#C299C5'
        />
        <path
          d='M32.8119 36.7835C28.7343 38.6073 23.6435 38.231 19.5825 36.8332V32.3792C19.5825 30.204 21.6998 27.7516 24.5492 27.7516C24.7642 27.7516 27.7501 27.764 27.9486 27.764C30.9964 27.764 32.8037 30.5431 32.8037 32.7184C32.8037 33.5289 32.8119 35.9689 32.8119 36.7835Z'
          fill='#C299C5'
        />
        <path
          d='M34.5695 33.576C34.7059 30.1394 33.639 27.8194 30.3347 26.678C31.2776 25.7517 31.8318 24.5731 31.778 23.3407H35.1898C37.7166 23.3407 40.0738 25.4208 40.0738 28.1916L40.049 32.3064C38.4237 33.2121 36.4098 33.4354 34.5695 33.5719V33.576Z'
          fill='#C299C5'
        />
        <path
          d='M26.1869 26.2602C28.3338 26.2602 30.0743 24.5197 30.0743 22.3728C30.0743 20.2259 28.3338 18.4854 26.1869 18.4854C24.0399 18.4854 22.2995 20.2259 22.2995 22.3728C22.2995 24.5197 24.0399 26.2602 26.1869 26.2602Z'
          fill='#C299C5'
        />
        <path
          d='M20.6207 21.2253C18.0939 22.6438 15.5216 21.2253 14.8475 19.0955C14.1734 16.9658 15.3934 14.5093 17.8458 14.0833C20.5586 13.6119 22.5313 15.8326 22.4238 18.1485C21.4726 18.7895 20.7199 20.0095 20.6207 21.2253Z'
          fill='#C299C5'
        />
        <path
          d='M31.7783 21.487C31.6211 19.8079 30.5872 18.4639 29.5658 17.856C29.6692 14.7213 33.2381 12.8272 35.9965 15.0108C38.7548 17.1943 36.836 23.1536 31.7783 21.487Z'
          fill='#C299C5'
        />
      </g>
    </svg>
  );
}

DarkFaqClassGroups.displayName = 'DarkFaqClassGroups';

export default DarkFaqClassGroups;
